import { useWorkingPlatform } from '@repo/platform';
import { AuthGuard } from '@repo/user-session';
import { GetServerSideProps } from 'next';
import { ReactElement, useMemo } from 'react';

import Spinner from '@/components/common/Spinner';
import { SectionScrollModelProvider } from '@/components/common/context/SectionScrollModelProvider';
import { 개인사업자고액환급액기준금액, 법인사업자고액환급액기준금액 } from '@/components/tax-refund/common/config/condition';
import { LookupRefundResultContent } from '@/components/tax-refund/lookup/result/LookupRefundResultContent';
import { LookupResultContextProvider } from '@/components/tax-refund/lookup/result/LookupResultContext';
import { ResultPageLayout } from '@/components/tax-refund/lookup/result/ResultPageLayout';
import { getRefundDataForWebStorage } from '@/components/tax-refund/lookup/result/utils';
import { BusinessType } from '@/lib/types/request';

export const getServerSideProps = (async ({ query }) => {
  if (query?.type) {
    return { props: { businessType: query?.type as BusinessType } };
  }
  return { props: { businessType: '' } };
}) satisfies GetServerSideProps;

function TaxRefundLookupResultPage({ businessType }: { businessType: BusinessType }) {
  const { refundAmount } = getRefundDataForWebStorage(businessType);
  const { workingPlatform } = useWorkingPlatform();

  const isVIP = useMemo(() => {
    return (
      (businessType === 'corps' ? Number(refundAmount) >= 법인사업자고액환급액기준금액 : Number(refundAmount) >= 개인사업자고액환급액기준금액) &&
      workingPlatform === 'web'
    );
  }, [businessType, refundAmount, workingPlatform]);

  if (!businessType) {
    return <Spinner />;
  }

  return (
    <LookupResultContextProvider businessType={businessType}>
      <ResultPageLayout isVIP={isVIP}>
        <LookupRefundResultContent />
      </ResultPageLayout>
    </LookupResultContextProvider>
  );
}

TaxRefundLookupResultPage.getLayout = (page: ReactElement) => {
  return (
    <AuthGuard>
      <SectionScrollModelProvider>{page}</SectionScrollModelProvider>
    </AuthGuard>
  );
};

export default TaxRefundLookupResultPage;
